<nz-form-control [nzErrorTip]="errorMessage | translate:translationData"
	[class.large-form]="isWizard" class="text-input">
	<input nz-input [(ngModel)]="selected" [name]="question.type"
		[maxlength]="maxLength"
		[minlength]="minLength"
		(ngModelChange)="onTextChange()"
		[disabled]="finishedAndLocked || isLocked"
		[ngClass]="{'large-input-field': isWizard}"
		[required]="!this.question.isAnswerOptional"
		(focusin)="disableSwipe()"
		(focusout)="enableSwipe()"
	/>
</nz-form-control>
